/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import { type FieldContentsData, type TagStructure } from '../../shared-types';
import { Rect } from '@lib/canvasx/components/Rect';

export const TagField: CanvaSXFC<{
  tag: TagStructure;
  contents: FieldContentsData;
  fieldId: RecordId;
}> = function ({ tag }) {
  const { color, name } = tag;

  return (
    <Rect margin={{ vertical: 2 }}>
      <Rect
        fill={color}
        borderRadius={2}
        padding={{ horizontal: 4, vertical: 2 }}
      >
        {/* Tag text is always white, since it will be on a colored background */}
        <Text color='#fff' size={9} maxWidth={200} overflow='…'>
          {name}
        </Text>
      </Rect>
    </Rect>
  );
};
